/* eslint react-hooks/exhaustive-deps: "warn" */

import styles from './AboutSections.module.scss';

import { SectionWhoWeAre } from './SectionWhoWeAre/SectionWhoWeAre';
import { SectionSince2015 } from './SectionSince2015/SectionSince2015';
import { SectionHowItWorks } from './SectionHowItWorks/SectionHowItWorks';
import { SectionOurDNA } from './SectionOurDNA/SectionOurDNA';
import { SectionWhatsNext } from './SectionWhatsNext/SectionWhatsNext';

export const AboutSections = () => (
  <div className={styles.root}>
    <SectionWhoWeAre />
    <SectionSince2015 />
    <SectionHowItWorks />
    <SectionOurDNA />
    <SectionWhatsNext />
  </div>
);
